import * as React from 'react';
import { Icon } from 'glints-aries/lib/@next';
import { IconNames } from 'glints-aries/lib/@next/Icon/icons/icons';
import {
  defineMessages,
  FormattedMessage,
  type MessageDescriptor,
} from 'react-intl';

import * as Styled from './Stats.sc';

interface StatItem {
  id: string;
  iconName: IconNames;
  number: string;
  hasPlus?: boolean;
  label: MessageDescriptor;
}

const messages = defineMessages({
  organizations: {
    id: 'landing-sg.stats.organizations',
    defaultMessage: 'Global organizations served',
  },
  countries: {
    id: 'landing-global.stats.countries',
    defaultMessage: 'Countries we hire in',
  },
  years: {
    id: 'landing-sg.stats.years',
    defaultMessage: 'Years building the ecosystem',
  },
});

const stats: StatItem[] = [
  {
    id: 'organizations',
    iconName: 'ri-building-fill',
    number: '55K',
    hasPlus: true,
    label: messages.organizations,
  },
  {
    id: 'countries',
    iconName: 'ri-global-line',
    number: '150',
    hasPlus: true,
    label: messages.countries,
  },
  {
    id: 'years',
    iconName: 'ri-timer3-fill',
    number: '10',
    hasPlus: true,
    label: messages.years,
  },
];

export const Stats: React.FC = () => (
  <Styled.Section>
    <Styled.Inner>
      <Styled.Head>
        <FormattedMessage
          id="landing-sg.stats.eyebrow"
          defaultMessage="By the numbers"
          tagName={Styled.Eyebrow}
        />
        <FormattedMessage
          id="landing-global.stats.title"
          defaultMessage="A decade of connecting talent and teams worldwide"
          tagName={Styled.Title}
        />
      </Styled.Head>

      <Styled.Grid>
        {stats.map((stat) => (
          <Styled.CardWrapper key={stat.id}>
            <Styled.Card>
              <Styled.IconWrap>
                <Icon name={stat.iconName} />
              </Styled.IconWrap>
              <Styled.Number>
                {stat.number}
                <If condition={Boolean(stat.hasPlus)}>
                  <Styled.Plus>+</Styled.Plus>
                </If>
              </Styled.Number>
              <FormattedMessage {...stat.label} tagName={Styled.Label} />
            </Styled.Card>
          </Styled.CardWrapper>
        ))}
      </Styled.Grid>
    </Styled.Inner>
  </Styled.Section>
);

export default Stats;
